export default __webpack_public_path__ + "static/media/org.c6749ec8.svg";